import { render } from "./phone.vue?vue&type=template&id=0fcc5314&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import "./phone.vue?vue&type=style&index=0&id=0fcc5314&lang=scss&scoped=true"

import exportComponent from "D:\\work\\zwkj\\cdzblue\\loginform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcc5314"]])

export default __exports__